import React from 'react'
import { Link } from 'gatsby'
export default class Steps extends React.Component {
    constructor(props) {
        super(props);
    }

    imageStyles = {
        maxWidth: '100%',
        height: "auto"
    }

    render() {
        const stepList = [];
        if(this.props.stepList != undefined) {
            this.props.stepList.forEach((step, index) => {
                stepList.push(
                    // parent
                    <div className={`setup_item row ${(index%2 != 0 ? 'flex-row-reverse' : '')}`}>
                        {/* CHILD image*/}
                        <div className="col-md-5 setup_img wow fadeInLeft" data-wow-delay="0.2s">
                            <img src={step.imageSrc} alt="Step Screenshot" style={this.imageStyles}/>
                        </div>
                    {/* CHILD  number */}
                        <div className="col-md-2 s_number">
                            <div className="round">{(index + 1)}</div>
                        </div>
                        {/* CHILD paragraph*/}
                        <div className="col-md-5">
                            <div className="setup_content wow fadeInRight" data-wow-delay="0.4s">
                                <h5>{step.title}</h5>
                                <p>{step.subtitle}</p>
                            </div>
                        </div>
                        {/* CHILD grey line hidden in mobile*/}
                        <div className="line bottom_half wow height" data-wow-delay="0.5s"></div>
                    </div>
                )
            });
        }

        return (
            <section className="easy_setup_area sec_pad">
                <div className="container">
                    <div className="hosting_title analytices_title text-center">
                        <h2 className="wow fadeInUp" data-wow-delay="0.2s"><span>{this.props.title}</span></h2>
                        <p className="wow fadeInUp" data-wow-delay="0.4s">{this.props.subtitle}</p>
                    </div>
                    <div className="setup_inner" style={{marginBottom: '30px'}}>
                        {stepList}
                    </div>
               
                </div>
            </section>
        )
    }
}